import { createFileRoute } from "@tanstack/react-router";
import { BlockRunner } from "@/features/sessions";

/**
 * ONE BLOCK, PUSHED FROM THE SESSION — the warm-up, the ramp, the accessory work, the cooldown.
 *
 * ⚠️ ONE ROUTE FOR ALL OF THEM, ADDRESSED BY ID, and that is deliberate rather than lazy. The
 * engine ships six blocks and may add a seventh; two of them have a tool of their own (the
 * strength log, the timer) and the rest are a list to read and a thing to tick off. A route per
 * block id would be four files that differ only in a string, and the fifth would be the one
 * nobody adds — which is exactly how `ramp` fell out of every screen that hard-coded a list.
 *
 * The screen owns its own header bar and its own footer, the way the strength log it sits
 * beside does, so the route renders it whole rather than putting a title above it.
 */
export const Route = createFileRoute("/_app/session/$id/block/$block")({
  component: BlockScreen,
});

function BlockScreen() {
  /* ⚠️ THE PARAM IS `block` AND NOT `blockId`, and the constraint is the filename rather than
     taste: TanStack builds the URL out of it, `make check-arch` refuses a capital letter in a
     route file, and `$blockid` would be worse to read than dropping the suffix. */
  const { id, block } = Route.useParams();

  return <BlockRunner sessionId={id} blockId={block} />;
}
